// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PackageVersionStatus_DesignPackageFragmentDoc } from './PackageVersionStatus.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductOfferingStatusSummaryQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProductOfferingStatusSummaryQuery = { __typename?: 'Query', productOfferings: { __typename?: 'ProductOfferingsPageResult', entities: Array<{ __typename?: 'ProductOffering', id: string, effectiveStatus: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus }, planPackage: { __typename?: 'PlanPackage', id: string }, interiorDesignPackage: { __typename?: 'DesignPackage', id: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, readyPlan:
              | { __typename?: 'ReadyPlan', id: string }
              | { __typename?: 'PlanPackage', id: string }
              | { __typename?: 'DesignPackage', id: string }
              | { __typename?: 'ProductOffering', id: string }
             } }> }, exteriorDesignPackage: { __typename?: 'DesignPackage', id: string, availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, readyPlan:
              | { __typename?: 'ReadyPlan', id: string }
              | { __typename?: 'PlanPackage', id: string }
              | { __typename?: 'DesignPackage', id: string }
              | { __typename?: 'ProductOffering', id: string }
             } }> } }> } };


export const ProductOfferingStatusSummaryDocument = gql`
    query ProductOfferingStatusSummary($projectId: ID!) {
  productOfferings(
    filter: {project: [$projectId], effectiveStatus: [ACTIVE, DRAFT], versionMode: LATEST}
  ) {
    entities {
      id
      effectiveStatus {
        code
      }
      planPackage {
        id
      }
      interiorDesignPackage {
        ...PackageVersionStatus_DesignPackage
      }
      exteriorDesignPackage {
        ...PackageVersionStatus_DesignPackage
      }
    }
  }
}
    ${PackageVersionStatus_DesignPackageFragmentDoc}`;

/**
 * __useProductOfferingStatusSummaryQuery__
 *
 * To run a query within a React component, call `useProductOfferingStatusSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOfferingStatusSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOfferingStatusSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProductOfferingStatusSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables> & ({ variables: ProductOfferingStatusSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>(ProductOfferingStatusSummaryDocument, options);
      }
export function useProductOfferingStatusSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>(ProductOfferingStatusSummaryDocument, options);
        }
// @ts-ignore
export function useProductOfferingStatusSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>;
export function useProductOfferingStatusSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProductOfferingStatusSummaryQuery | undefined, ProductOfferingStatusSummaryQueryVariables>;
export function useProductOfferingStatusSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>(ProductOfferingStatusSummaryDocument, options);
        }
export type ProductOfferingStatusSummaryQueryHookResult = ReturnType<typeof useProductOfferingStatusSummaryQuery>;
export type ProductOfferingStatusSummaryLazyQueryHookResult = ReturnType<typeof useProductOfferingStatusSummaryLazyQuery>;
export type ProductOfferingStatusSummarySuspenseQueryHookResult = ReturnType<typeof useProductOfferingStatusSummarySuspenseQuery>;
export type ProductOfferingStatusSummaryQueryResult = ApolloReactCommon.QueryResult<ProductOfferingStatusSummaryQuery, ProductOfferingStatusSummaryQueryVariables>;